<template>
  <pict
    class="privacy__image m-auto"
    block-name="privacy"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"
import imageL from "./images/privacy.png"
import imageL2x from "./images/privacy@2x.png"

export default {
  name: "PrivacyImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "A person with short dark hair  and blue glasses, wearing a black sweater and juggling black, blue and yellow books"
      },
      de: {
        alt: "Eine Person in einem schwarzen Pullover jongliert drei Bücher. Eines ist schwarz, eines blau und eines gelb."
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.privacy {
  ::v-deep &__image {
    width: auto;
  }
}
</style>
